import React from "react";
import _ from "lodash";
import { store } from "statorgfc";
import { MenuNav } from "@obby/components";
import { urls } from "../../settings";
import AuthenticationState from "../../state/AuthenticationState";
import { styles } from "./JoinHeader.style";

export class JoinHeader extends React.Component {
  constructor(props) {
    super(props);

    this.onScroll = _.throttle(() => {
      this.setState({ isOnTop: window.scrollY === 0 });
    }, 250);

    this.state = {
      isOnTop: true,
    };

    store.connectComponentState(this, ["categories", "authentication"]);
  }

  componentDidMount() {
    addEventListener("scroll", this.onScroll);
    if (window.scrollY > 0) this.setState({ isOnTop: false });
  }

  componentWillUnmount() {
    removeEventListener("scroll", this.onScroll);
  }

  onSignIn() {
    AuthenticationState.events.beginSignIn.next();
  }

  onSignOut() {
    AuthenticationState.events.signOut.next();
  }

  onStartTeaching() {
    window.open(`${urls.teachers}/signup`, "_blank");
  }

  render() {
    const avatarUrl = this.state.authentication.user?.profile?.imageUrl;
    const isSignedIn = AuthenticationState.helpers.isSignedIn();

    return (
      <div
        className={`${styles.joinHeader()} ${
          !this.state.isOnTop ? styles.filled() : ""
        }`}
      >
        <MenuNav
          isSignedIn={isSignedIn}
          onSignOut={this.onSignOut.bind(this)}
          avatarUrl={avatarUrl}
        >
          <MenuNav.Item text="Teaching on Obby" href="/join" bold />
          <MenuNav.Item text="Features" href="/features" />
          <MenuNav.Item text="Pricing" href="/pricing" />
          {/*<MenuNav.Item text="Support" href="#" />*/}
          <MenuNav.Item
            text="Start teaching"
            mobile
            onClick={this.onStartTeaching.bind(this)}
          />
          <MenuNav.Space desktop />
          {!isSignedIn && (
            <MenuNav.Item
              text="Log in"
              desktop
              onClick={this.onSignIn.bind(this)}
            />
          )}
          {!isSignedIn && (
            <MenuNav.Button
              text="Log in"
              mobile
              onClick={this.onSignIn.bind(this)}
            />
          )}
          <MenuNav.Button
            text="Start teaching"
            desktop
            onClick={this.onStartTeaching.bind(this)}
          />
        </MenuNav>
      </div>
    );
  }
}
